export default function() {
  /* 表格列头（用 min-width 让整行铺满，不再出现右侧大片空白） */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "门店ID", prop: "store_id", minWidth: 120 },
    { label: "卡号", prop: "vip_number", minWidth: 200 },
    { label: "状态", prop: "card_status", slots: "card_status", minWidth: 100 },
    { label: "会员姓名", prop: "user_name", minWidth: 120 },
    { label: "会员手机号", prop: "user_phone", minWidth: 150 },
    { label: "金额", prop: "money", minWidth: 100 },
    {
      label: "绑定时间",
      prop: "bind_card_time",
      minWidth: 180,
    },
    {
      label: "会员卡生成时间",
      prop: "create_time",
      minWidth: 180,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 100,
      slots: "operation",
    },
  ];
}
